export type QueryParamsMapType = {
	readonly workfileId: string;
	readonly projectNumber: string;
	readonly entityName: string;
	readonly entryId: string;
	readonly tableName: string;
	readonly childEntryId: string;
	readonly editMode: string;
	readonly dupMode: string;
	readonly newFromMode: string;
	readonly connectionId: string;
	readonly userGuideComponent: string;
	readonly tableMode: string;
};

export class AppRoutingKeys {
	public static readonly urlPathLogin = 'login';
	public static readonly urlPathWorkfile = 'workfile';
	public static readonly urlPathProject = 'project';
	public static readonly urlPathEntity = 'entity';
	public static readonly urlPathTable = 'child-table';
	public static readonly urlPathEntryNew = 'new';
	public static readonly urlPathEntryEdit = 'edit';
	public static readonly urlPathEntryPreview = 'preview';
	public static readonly urlPathEntryDup = 'duplicate';
	public static readonly urlPathEntryNewFrom = 'newFrom';
	public static readonly urlPathEntryDetails = 'entry';
	public static readonly urlPathChildEntryDetails = 'child-entry';
	public static readonly urlPathPlayground = 'playground';
	public static readonly urlPathExport = 'export';
	public static readonly urlPathEntityStandard = 'standard';
	public static readonly urlPathAbout = 'about';
	public static readonly urlPathHelp = 'help';
	public static readonly urlPathUserGuide = 'user-guide';
	public static readonly urlPathSettings = 'settings';
	public static readonly urlPathSettingsSync = 'sync';
	public static readonly urlPathRegistration = 'registration';
	public static readonly urlPathResetPin = 'reset';
	public static readonly urlPathRegistrationUsername = 'username';
	public static readonly urlPathRegistrationPin = 'pin';
	public static readonly urlPathRegistrationFusionPassword = 'password';
	public static readonly urlPathImport = 'import';
	public static readonly urlPathImportFile = 'file';
	public static readonly urlPathImportTransferOut = 'transfer-out';
	public static readonly urlPathImportTransferOutAuthentication = 'authentication';
	public static readonly urlPathImportTransferOutManually = 'manually';
	public static readonly urlPathImportTransferOutQrCode = 'qrcode';
	public static readonly urlPathImportTransferOutOptions = 'options';
	public static readonly urlPathNoApiMode = 'noapimode';

	public static readonly urlPathConnections = 'connections';
	public static readonly urlPathConnectionsAdd = 'manually';
	public static readonly urlPathConnectionsQrCode = 'qrcode';
	public static readonly urlPathConnectionsOptions = 'options';
	public static readonly urlPathGPSActivation = 'gps';
	public static readonly urlPathViewConfiguration = 'view-config';

	public static readonly queryParamsMap: QueryParamsMapType = {
		workfileId: 'workfileId',
		projectNumber: 'projectNumber',
		entityName: 'entityName',
		entryId: 'entryId',
		tableName: 'tableName',
		childEntryId: 'childEntryId',
		editMode: AppRoutingKeys.urlPathEntryEdit,
		dupMode: AppRoutingKeys.urlPathEntryDup,
		newFromMode: AppRoutingKeys.urlPathEntryNewFrom,
		connectionId: 'connectionId',
		userGuideComponent: 'userGuideComponent',
		tableMode: 'tableMode',
	};

	private static readonly queryParamsObject = {};
	public static getParamObject(): QueryParamsMapType {
		Object.values(AppRoutingKeys.queryParamsMap).map((key) => (AppRoutingKeys.queryParamsObject[key] = null));
		console.log("This is object: ", this.queryParamsObject);
		
		return this.queryParamsObject as QueryParamsMapType;
	}
}
